export default __webpack_public_path__ + "static/media/cross-white.50647189.svg";